import { recaptcha } from "@turo/libraries/lib/recaptcha/recaptcha";

import config from "../config";
import type { CommonTranslations } from "../pages/locales/types";
import type { Translate } from "../SimpleTranslateProvider";

export const RECAPTCHA_TOKEN_ERROR = "RECAPTCHA_TOKEN_ERROR";

interface GetRecaptchaTokenParams {
  translate: Translate<CommonTranslations>;
}

export interface RecaptchaError {
  error: typeof RECAPTCHA_TOKEN_ERROR;
  errors: readonly [{ message: string }];
}

export const getRecaptchaToken = ({
  translate,
}: GetRecaptchaTokenParams): Promise<string | RecaptchaError> => {
  return recaptcha
    .execute(recaptcha.ACTIONS.LOGIN, config.GOOGLE_CAPTCHA_SITE_KEY)
    .catch((_error) => {
      return {
        error: RECAPTCHA_TOKEN_ERROR,
        errors: [{ message: translate("common.error_generic") }],
      } as const;
    });
};

export const initializeRecaptcha = (): void => {
  recaptcha
    .initialize(config.GOOGLE_CAPTCHA_SITE_KEY)
    .catch((error: unknown) => {
      /**
       * TODO: Should we add error reporting to this repo?
       */
      return error;
    });
};
